import {useEffect, useState} from 'react'

// rsuite
import Table from 'rsuite/Table'
import Tooltip from 'rsuite/Tooltip'
import Whisper from 'rsuite/Whisper'

// includes
import axios from 'axios'
import {isEmpty} from 'lodash'
import {FiEye, FiX} from 'react-icons/fi'
import {useParams} from 'react-router-dom'
import {toast} from 'react-toastify'
import {SortType} from 'rsuite-table/lib/@types/common'
import Pagination from 'rsuite/Pagination'
import IconButton from 'rsuite/esm/IconButton'
import {StateParamsModel} from 'src/app/modules/common/Model'
import CheckPermissions from 'src/app/modules/common/checkPermission'
import DeleteModal from 'src/app/modules/common/components/deleteModal'
import DesignComponent from 'src/app/modules/common/components/designComponent'
import RSuiteTable from 'src/cms/helpers/components/rsuiteTable'
import {careerValidation} from 'src/cms/helpers/constants'
import ViewCandidateDetails from '../../vacancy/component/ViewCandidateDetails'
const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

const CandidatesList = () => {
  const [showViewCandidateDetailsModal, setShowViewCandidatesModal] = useState(false)
  const [selectedCandidateId, setSelectedCandidateId] = useState('')
  const parameters: any = useParams()
  const [data, setData] = useState<any>([])
  const [metaData, setMetaData] = useState({total: 0})
  const [loading, setLoading] = useState(false)
  const [showRemoveFromShortlistConfirmPopup, setShowRemoveFromShortlistConfirmPopup] =
    useState(false)

  const [params, setParams] = useState<StateParamsModel>({
    page: 1,
    limit: 10,
    search: '',
    fromDate: '',
    toDate: '',
    order: '',
    orderBy: '',
  })

  const [provinceData, setProvinceData] = useState([])
  const [districtData, setDistrictData] = useState([])
  const [municipalityData, setMunicipalityData] = useState([])
  const [zoneData, setZoneData] = useState([])
  const [functionalAreaData, setFunctionalAreaData] = useState([])
  const [branchData, setBranchData] = useState([])
  const [departmentData, setDepartmentData] = useState([])
  const [vacancyApplicantStatusData, setVacancyApplicantStatusData] = useState<any>([])

  useEffect(() => {
    axios.get(API_URL + '/province').then((res) => {
      setProvinceData(res.data.data.province)
    })
    axios.get(API_URL + '/district').then((res) => {
      setDistrictData(res.data.data.district)
    })
    axios.get(API_URL + '/zone').then((res) => {
      setZoneData(res.data.data.zone)
    })
    axios.get(API_URL + '/municipality').then((res) => {
      setMunicipalityData(res.data.data.municipality)
    })
    axios.get(API_URL + '/functionalarea').then((res) => {
      setFunctionalAreaData(res.data.data.functionalArea)
    })
    axios.get(API_URL + '/branch').then((res) => {
      setBranchData(res.data.data.branch)
    })
    axios.get(API_URL + '/department').then((res) => {
      setDepartmentData(res.data.data.department)
    })
    axios.get(API_URL + '/vacancy-applicant-status').then((res) => {
      setVacancyApplicantStatusData(res.data.data.vacancyApplicantStatus)
    })
  }, [])

  const getData = () => {
    setLoading(true)
    axios
      .get(
        API_URL +
          `/on-boarded?vacancyId=${parameters?.vacancyId}&search=${params.search}&limit=${params.limit}&page=${params.page}&fromDate=${params.fromDate}&toDate=${params.toDate}&orderBy=${params.orderBy}&order=${params.order}`
      )
      .then((res) => {
        setData(res.data.data.vacancyApplicant)
        setMetaData(res.data.data.meta)
        setLoading(false)
      })
  }

  useEffect(() => {
    getData()
  }, [parameters?.vacancyId, params])

  const [checkedValues, setCheckedValues] = useState<Array<string>>([])
  const [editSelectedData, setEditCheckedData] = useState<any>()

  // alert modal
  const [alertOpen, setAlertOpen] = useState(false)
  const handleAlertOpen = () => setAlertOpen(true)
  const handleAlertClose = () => setAlertOpen(false)

  const handleChecked = (values: Array<string>) => {
    setCheckedValues(values)
  }

  const ActionCell = ({rowData, dataKey, ...props}: any) => {
    return (
      <Cell {...props} className='link-group' data-cy='career-onboard-link-group'>
        <CheckPermissions type='Edit'>
          <Whisper
            placement='top'
            trigger='hover'
            data-cy='career-onboard-edit-button'
            speaker={<Tooltip>View Details</Tooltip>}
          >
            <IconButton
              onClick={() => {
                setShowViewCandidatesModal(true)
                setSelectedCandidateId(rowData?.id)
              }}
              data-cy='edit-button'
              appearance='subtle'
              icon={<FiEye />}
            />
          </Whisper>
        </CheckPermissions>
        <CheckPermissions type='Delete'>
          <Whisper
            placement='top'
            trigger='hover'
            speaker={<Tooltip>Remove From Shortlist</Tooltip>}
            data-cy='career-onboard-delete-button'
          >
            <IconButton
              appearance='subtle'
              onClick={() => {
                setShowRemoveFromShortlistConfirmPopup(true)
                setSelectedCandidateId(rowData?.id)
              }}
              data-cy='delete-button'
              icon={<FiX />}
            />
          </Whisper>
        </CheckPermissions>
      </Cell>
    )
  }

  const Cell = Table.Cell

  const columns =
    careerValidation === 'true'
      ? [
          {
            label: 'S.N.',
            dataKey: 'sn',
            width: 60,
            cell: <Cell dataKey='sn' />,
          },
          {
            label: 'Unique Code',
            dataKey: 'unique_code',
            width: 120,
            cell: <Cell dataKey='unique_code' />,
            sortable: true,
          },
          {
            label: 'Name',
            dataKey: 'full_name',
            flexGrow: 1,
            cell: <Cell dataKey='full_name' />,
            sortable: true,
          },
          {
            label: 'Email',
            dataKey: 'email',
            flexGrow: 1,
            cell: <Cell dataKey='email' />,
            sortable: false,
          },
          {
            label: 'Exam Marks',
            width: 70,
            cell: (
              <Cell>
                {(rowData) => {
                  return <p>{rowData?.vacancyApplicantExamMark?.examMark || 'N/A'}</p>
                }}
              </Cell>
            ),
            sortable: false,
          },
          {
            label: 'Group Discussion Marks',
            width: 70,
            cell: (
              <Cell>
                {(rowData) => {
                  return (
                    <p>
                      {rowData?.vacancyApplicantGroupDiscussionMark?.groupDiscussionMark || 'N/A'}
                    </p>
                  )
                }}
              </Cell>
            ),
            sortable: false,
          },
          {
            label: 'Interview Marks',
            width: 70,
            cell: (
              <Cell>
                {(rowData) => {
                  return <p>{rowData?.vacancyApplicantInterviewMark?.interview_marks || 'N/A'}</p>
                }}
              </Cell>
            ),
            sortable: false,
          },
          {
            label: 'Applied Date',
            dataKey: 'appliedDate',
            flexGrow: 1,
            cell: <Cell dataKey='appliedDate' />,
            sortable: false,
          },
          {
            label: 'Status',
            dataKey: 'status',
            width: 200,
            cell: (
              <Cell>
                {(rowData) => {
                  return (
                    <p>
                      {vacancyApplicantStatusData.filter(
                        (d: {id: string}) => d.id === rowData?.vacancyApplicantStatusId
                      )[0]?.displayName || 'N/A'}
                    </p>
                  )
                }}
              </Cell>
            ),
            sortable: false,
          },
          {
            label: 'Action',
            width: 150,
            align: 'center',
            cell: <ActionCell dataKey='id' />,
          },
        ]
      : [
          {
            label: 'S.N.',
            dataKey: 'sn',
            width: 50,
            cell: <Cell dataKey='sn' />,
          },
          {
            label: 'Unique Code',
            dataKey: 'unique_code',
            width: 120,
            cell: <Cell dataKey='unique_code' />,
            sortable: true,
          },
          {
            label: 'Name',
            dataKey: 'full_name',
            width: 180,
            cell: <Cell dataKey='full_name' />,
            sortable: true,
          },
          {
            label: 'Email',
            dataKey: 'email',
            width: 180,
            cell: <Cell dataKey='email' />,
            sortable: false,
          },
          {
            label: 'Exam Marks',
            width: 90,
            cell: (
              <Cell>
                {(rowData) => {
                  return <p>{rowData?.vacancyApplicantExamMark?.examMark || 'N/A'}</p>
                }}
              </Cell>
            ),
            sortable: false,
          },
          {
            label: 'Interview Marks',
            width: 115,
            cell: (
              <Cell>
                {(rowData) => {
                  return <p>{rowData?.vacancyApplicantInterviewMark?.interview_marks || 'N/A'}</p>
                }}
              </Cell>
            ),
            sortable: false,
          },
          {
            label: 'Applied Date',
            dataKey: 'appliedDate',
            width: 105,
            cell: <Cell dataKey='appliedDate' />,
            sortable: false,
          },
          {
            label: 'Status',
            dataKey: 'status',
            width: 180,
            cell: (
              <Cell>
                {(rowData) => {
                  return (
                    <p>
                      {vacancyApplicantStatusData.filter(
                        (d: {id: string}) => d.id === rowData?.vacancyApplicantStatusId
                      )[0]?.displayName || 'N/A'}
                    </p>
                  )
                }}
              </Cell>
            ),
            sortable: false,
          },
          {
            label: 'Action',
            width: 80,
            align: 'center',
            cell: <ActionCell dataKey='id' />,
          },
        ]

  const vacancyData =
    data?.length > 0
      ? data?.map((item: any, i: number) => ({
          sn: (params?.page - 1) * params?.limit + (i + 1),
          id: item.id,
          jobCode: item.jobCode,
          slug: item.slug,
          name: item.name,
          full_name: item.name,
          uniqueCode: item.uniqueCode,
          unique_code: item.uniqueCode,
          appliedDate: item.appliedDate,
          email: item.email,
          status: item.status,
          vacancyApplicantExamMark: item.vacancyApplicantExamMark,
          vacancyApplicantGroupDiscussionMark: item.vacancyApplicantGroupDiscussionMark,
          vacancyApplicantInterviewMark: item.vacancyApplicantInterviewMark,
          vacancyApplicantStatusId: item.vacancyApplicantStatusId,
        }))
      : []

  const handleSort = (dataKey: string, sortType?: SortType) => {
    setParams({...params, orderBy: dataKey, order: sortType})
  }

  const handleExport = () => {
    axios
      .get(
        API_URL +
          `/on-boarded/export?vacancyId=${parameters.vacancyId}&fromDate=${params.fromDate}&toDate=${params.toDate}`
      )
      .then((response) => {
        const blob = new Blob([response.data])
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'onboarded-candidates.csv')
        document.body.appendChild(link)
        link.click()
      })
  }

  const handleDelete = () => {
    let vacancyId: any = checkedValues?.map((value) => ({vacancyId: value}))
    //axios.pos
    handleAlertClose()
  }

  const handleRefresh = () => {
    getData()
  }

  const handleChangeLimit = (dataKey: number) => {
    setParams({
      ...params,
      limit: dataKey,
    })
  }

  const changeCandidateStatus = (candidateId: string, actionType: string) => {
    setShowRemoveFromShortlistConfirmPopup(false)

    let selectedStatusId = vacancyApplicantStatusData.filter(
      (d: {systemName: string; id: string}) => d.systemName === actionType
    )[0]?.id
    axios
      .put(API_URL + `/apply-vacancy/${candidateId || selectedCandidateId}`, {
        vacancyApplicantStatusId: selectedStatusId,
      })
      .then((res) => {
        toast.success('Success.')
        const updatedData = [...data]
        setData(
          updatedData.filter((d: {id: string}) => d.id !== (candidateId || selectedCandidateId))
        )
      })
  }

  let inputTimer: any

  const handleDownloadResume = () => {
    let applicantIds = ''
    if (checkedValues.length > 0) {
      for (let e in checkedValues) {
        //creating comma seperated Ids
        applicantIds = applicantIds ? applicantIds + ',' + checkedValues[e] : checkedValues[e]
      }
    }

    !isEmpty(checkedValues)
      ? axios
          .get(API_URL + `/apply-vacancy/get-resume?vacancyApplicantId=${applicantIds}`, {
            responseType: 'blob',
          })
          .then((res) => {
            const blob = new Blob([res.data])
            const url = window.URL.createObjectURL(blob)

            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'onboarded-candidates-resume.zip')
            document.body.appendChild(link)
            link.click()
            link.remove()
          })
          .catch((err) => {
            console.error(err)
            toast.error('Download failed')
          })
      : toast.error('No data selected')
  }

  return (
    <>
      <div className='shadow p-3 bg-white rounded' data-cy='career-onboard-shadow-comp'>
        <DesignComponent
          moduleName='Onboarded Candidates List'
          params={params}
          setParams={(data: any) => {
            const duration = 1000
            clearTimeout(inputTimer)
            inputTimer = setTimeout(() => {
              setParams(data)
            }, duration)
          }}
          handleRefresh={handleRefresh}
          handleAlertOpen={handleAlertOpen}
          handleExport={handleExport}
          importShow={false}
          toggleMultipleShow={false}
          addShow={false}
          deleteShow={false}
          filterData={true}
          downloadResumeShow
          handleDownloadResume={handleDownloadResume}
          data-cy='career-onboard-design-comp'
        />

        <div className='datatable' data-cy='career-onboard-datatable'>
          <RSuiteTable
            onChecked={handleChecked}
            showCheckbox={true}
            columns={columns}
            data={vacancyData}
            checkedValues={checkedValues}
            showLoading={loading}
            handleSort={handleSort}
            data-cy='career-onboard-r-suite'
          />

          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            className='mt-5'
            maxButtons={5}
            size='sm'
            layout={['total', '-', 'limit', '|', 'pager', 'skip']}
            total={metaData?.total || 0}
            limitOptions={[10, 20, 50, 100]}
            limit={params?.limit}
            activePage={params?.page}
            onChangePage={(value) => setParams({...params, page: value})}
            onChangeLimit={handleChangeLimit}
            data-cy='career-onboard-pagination'
          />

          {showViewCandidateDetailsModal && (
            <ViewCandidateDetails
              handleClose={() => setShowViewCandidatesModal(false)}
              data={data?.filter((d: any) => d.id === selectedCandidateId)[0]}
              provinceList={provinceData}
              districtList={districtData}
              zoneList={zoneData}
              functionalAreaList={functionalAreaData}
              municipalityList={municipalityData}
              departmentList={departmentData}
              branchList={branchData}
            />
          )}

          <>
            {alertOpen &&
              (!isEmpty(checkedValues) ? (
                <DeleteModal
                  handleClick={() => handleDelete()}
                  isOpen={alertOpen}
                  handleClose={() => handleAlertClose()}
                />
              ) : (
                toast.error('No data selected') && setAlertOpen(false)
              ))}
          </>

          {showRemoveFromShortlistConfirmPopup && (
            <DeleteModal
              handleClick={() => changeCandidateStatus('', 'pending')}
              isOpen={showRemoveFromShortlistConfirmPopup}
              handleClose={() => setShowRemoveFromShortlistConfirmPopup(false)}
              title='Remove'
            />
          )}
        </div>
      </div>
    </>
  )
}

export default CandidatesList
